import {
  parseQuestionnaireCustomAttributeData,
  parseQuestionnaireFormSchema,
  parseQuestionnaireFormUiSchema,
} from '@risksmart-app/components/src/form-builder/questionnaireSchemaContracts';
import {
  defaultSchema,
  defaultUISchema,
} from '@risksmart-app/components/src/form-builder/store/useFormBuilderStore';
import type {
  CustomSchema,
  CustomUISchema,
} from '@risksmart-app/components/src/form-builder/types';
import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import { nextTemplateVersion } from '@risksmart-app/shared/third-party/questionnaire-templates/templateVersionUtils';

import { useGetLatestQuestionnaireTemplateVersion } from '@/hooks/queries/questionnaire-template-version/useGetLatestQuestionnaireTemplateVersion';

interface PreviousQuestionnaireTemplateVersion {
  Version?: string | null;
  Schema?: unknown;
  UISchema?: unknown;
  CustomAttributeData?: unknown | null;
}

export const buildNextTemplateVersionDefaults = (
  previousVersion: PreviousQuestionnaireTemplateVersion | undefined
): {
  nextVersion: string;
  schema: CustomSchema;
  uiSchema: CustomUISchema;
  customAttributeData: CustomAttributeData | null | undefined;
} => ({
  nextVersion: nextTemplateVersion(previousVersion?.Version ?? undefined),
  schema: parseQuestionnaireFormSchema(previousVersion?.Schema, defaultSchema),
  uiSchema: parseQuestionnaireFormUiSchema(
    previousVersion?.UISchema,
    defaultUISchema
  ),
  customAttributeData: parseQuestionnaireCustomAttributeData(
    previousVersion?.CustomAttributeData
  ),
});

export const useNextTemplateVersion = (
  parentId: string
): [
  ReturnType<typeof buildNextTemplateVersionDefaults>,
  { loading: boolean },
] => {
  const { data, loading } = useGetLatestQuestionnaireTemplateVersion({
    queryArgs: { parentId },
  });

  const previousVersion =
    data?.questionnaire_template_version.length === 1
      ? data?.questionnaire_template_version[0]
      : undefined;

  return [buildNextTemplateVersionDefaults(previousVersion), { loading }];
};
